import React, { useState, useEffect, useCallback } from 'react'
import { Dialog, IconButton, DialogTitle, DialogContent, useMediaQuery } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { toast } from 'react-toastify'

import '../contactos/modalContacts.css'

import { Tasks } from '../../models/tasks'
// import { SeccionGeneral } from './SeccionGeneral'
import { Model } from '../../models/model'
import { SeccionGeneralSubs } from './SeccionGeneralSubs'

export const DialogFormTaskSubs = ({ open, setOpen, taskId, refreshObj }) => {

    const isMobile = useMediaQuery('(max-width:768px)')

    // const [previuosInfo, setPreviuosInfo] = useState({})
    const [form, setForm] = useState({
        id: taskId || 0,
        date_change_option: 'esta_tarea'
    })

    const handleGetTask = useCallback(async () => {

        if (parseFloat(taskId) > 0) {

            const resultTask = await Model.getOne({ url: `tasks/${taskId}` })

            setForm(prev => ({
                ...prev,
                ...resultTask
            }))

        }

    }, [taskId])

    /*   const handleGetTask = async () => {
          const resultTask = await Model.getOne({ url: `tasks/${taskId}` })
  
          setForm(prev => ({
              ...prev,
              ...resultTask
          }))
  
      } */


    const handleChange = ({ target }) => {
        setForm({
            ...form,
            [target.name]: target.value,
        });
    }

    const handleChangeDate = (newDates) => {
        console.log('--handleChangeDate KOKOKO--', form)

        setForm(prev => ({
            ...prev,
            fecha_inicio: newDates.fecha_inicio,
            fecha_fin: newDates.fecha_fin,
            edit_end_date: true,
            change_days: true
        }))

    }

    const handleSubmit = async (e) => {
        e.preventDefault()

        if (form.nombre === '') {
            toast.warn("Ingrese nombre tarea")
            return false
        }

        if (form.id > 0) {
            await Tasks.update(form)
        } else {
            const id = await Tasks.save(form)
            setForm({
                ...form,
                id: id
            })
        }

        if (refreshObj) {
            await refreshObj.fn_(refreshObj.filters_)
        }
    }

    useEffect(() => {
        if (parseFloat(taskId) > 0) {
            handleGetTask()
        }
    }, [taskId, handleGetTask])

    /*  useEffect(() => {
         if (parseFloat(taskId) > 0) {
             handleGetTask()
         }
     }, [taskId])
    */

    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="simple-dialog-title"
            fullScreen={isMobile}
            PaperProps={{
                className: isMobile ? '' : 'min-w-fit'
            }}
        >
            <div className={!isMobile ? `ContainerDialogs` : ''} style={{ width: !isMobile ? '700px' : '' }}>
                <DialogTitle id="scroll-dialog-title" style={{ position: 'absolute', right: '0px', top: '0px' }}>
                    <IconButton
                        aria-label="close"
                        style={{ padding: '0', float: 'right' }}
                        onClick={() => setOpen(false)}
                    >
                        <CloseIcon style={{ color: '#78667E' }} />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <SeccionGeneralSubs
                        modeEdit=""
                        form={form}
                        setForm={setForm}
                        handleChange={handleChange}
                        handleChangeDate={handleChangeDate}
                        handleSubmit={handleSubmit}
                        handleInitGetTasks={() => { return false }}
                    // previuosInfo={previuosInfo}
                    />
                </DialogContent>
            </div>
        </Dialog>
    )
}